import { api } from '../index';
import { objectToFormData } from '@/api/util.js';

const prefix = '/api/purchase/';

export function apiIndex() {
	return api.get(prefix + 'index');
}

export function apiSelectPurchaseList(param) {
	return api.post(prefix + 'selectPurchaseList', param);
}

export function apiSelectPurchaseItemList(param) {
	return api.post(prefix + 'selectPurchaseItemList', param);
}

export function apiSelectPurchase(param) {
	return api.post(prefix + 'selectPurchase', param);
}

export function apiCheckPurchaseExists(param) {
	return api.post(prefix + 'checkPurchaseExists', param);
}

export function apiInsertPurchase(param) {
	param.mode = 'insert';
	return apiSubmitPurchase(param);
}

export function apiUpdatePurchase(param) {
	param.mode = 'update';
	return apiSubmitPurchase(param);
	//return api.post(prefix + 'submitUser', param);
}

export function apiDeletePurchase(param) {
	param.mode = 'delete';
	return apiSubmitPurchase(param);
}

function apiSubmitPurchase(param) {
	return api.post(prefix + 'submitPurchase', param);
}

export function apiSelectPOStatus(param) {
	return api.post(prefix + 'selectPOStatus', param);
}

export function apiPreReceiving(param) {
	return api.post(prefix + 'preReceiving', param);
}

export function apiReceivedList(param) {
	return api.post(prefix + 'receivedList', param);
}

export function apiReceivedGoods(param) {
	return api.post(prefix + 'receivedGoods', param);
}

export function apiSelectOnBoardSchedule(param) {
	return api.post(prefix + 'selectOnBoardSchedule', param);
}

export function apiSelectOnBoardScheduleItemList(param) {
	return api.post(prefix + 'selectOnBoardScheduleItemList', param);
}

export function apiSelectOnOrderDetail(param) {
	return api.post(prefix + 'selectOnOrderDetail', param);
}

export function apiUpdateLastShipmentPrice(param) {
	return api.post(prefix + 'updateLastShipmentPrice', param);
}

export function apiSelectLastShipmentPrice(item_codes, item_class, vendor_code, sort_key, sort_direction) {
	return api.post(prefix + 'selectLastShipmentPrice', objectToFormData({ item_codes, item_class, vendor_code, sort_key, sort_direction }));
}

export function apiItemShipmentHistoryByVendor(item_id, vendor_code) {
	return api.get(prefix + 'itemShipmentHistoryByVendor', { params: { item_id, vendor_code } });
}
